import React, { useState } from 'react'
import FormularioEditalSP from './FormularioEditalSP'
import FormularioEditalVeiculo from './FomularioEditalVeiculo'

function EditalJuridico() {
    const [tipo, setTipo] = useState('')

    return (
        <div className='max-w-4xl mx-auto p-8 mt-10 mb-10 rounded-3xl bg-white shadow-sm shadow-neutral-200'>
            <h1 className="text-4xl font-semibold tracking-tight text-neutral-800 text-center mb-6">
                🏛️ Edital
            </h1>

            <div className='flex flex-col gap-2 w-[90%] m-auto'>
                <p className='font-semibold'>Selecione o tipo do Edital:</p>


                <select onChange={e => setTipo(e.target.value)} name="" id="">
                    <option value="">Selecione</option>
                    <option value="imovel">Imóvel</option>
                    <option value="movel">Móvel</option>
                    <option value="veiculo">Veículo</option>
                </select>
            </div>

            {
                tipo == 'imovel' && <FormularioEditalSP tipoEdital={tipo} />
            }

            {/* {
                tipo == 'movel' && <FormularioEditalSP />
            } */}

             {
                tipo == 'veiculo' && <FormularioEditalVeiculo  tipoEdital={tipo}/>
            }

        </div>
    )
}

export default EditalJuridico